import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            51吃瓜黑料网深度策划，聚焦娱乐圈最热门的话题专题
          </p>
        </div>

        <div className="space-y-6">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="flex flex-col md:flex-row bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 group cursor-pointer hover:border-primary-200 transition-colors"
            >
              <div className="w-full md:w-2/5 lg:w-1/3 flex-shrink-0 overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-48 md:h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) {
                      target.parentElement.style.minHeight = '200px';
                    }
                  }}
                />
              </div>
              <div className="flex-1 p-6 md:p-8 flex flex-col justify-center">
                <span className="inline-flex self-start px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
                  {item.tag}
                </span>
                <h3 className="text-xl md:text-2xl font-heading text-foreground-950 mb-3 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-4">
                  {item.desc}
                </p>
                <span className="text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-calendar-line"></i>
                  {item.date}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}